import { useState, useEffect } from 'react'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import { Typography } from '@mui/material'
import timezone from 'dayjs/plugin/timezone'
import advancedFormat from 'dayjs/plugin/advancedFormat'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(advancedFormat)


const Clock = ({ bi = false }) => {

  const [state, setState] = useState({ utc: '', la: { tz: '', time: '' } })

  useEffect(() => {
    const intervalId = setInterval(() => {
      const latime = dayjs.utc().tz('America/Los_Angeles')
      setState({ utc: dayjs.utc().format('YYYY-MM-DD HH:mm:ss'), la: { tz: latime.format('z'), time: latime.format('YYYY-MM-DD HH:mm:ss') } })
    }, 1000)

    return () => clearInterval(intervalId)
  }, [])

  return (
    <div style={bi ? { position: 'fixed', top: '110px', right: '10px' } : { padding: '18px 0px 0px 8px' }}>
      <Typography
        variant='subtitle2'
        style={{
          fontSize: '11px',
          margin: '0',
          padding: '5px 8px',
          background: 'rgba(200,200,200,0.3)',
          borderRadius: '12px',
          lineHeight: '2.0'
        }}>
        UTC : {state.utc} <br/>
        {state.la.tz} : {state.la.time}
      </Typography>
    </div>
  )
}

export default Clock